<template>
    <div class="content">
        <iframe :src="pdfUrl.file" frameborder="0"></iframe>
    </div>
</template>
<script>
import { getWxSingleConfig } from "@/js/wx.js";
import path from "@/path.js";
export default {
    data() {
        return {
            pdfUrl: "",
        };
    },
    created() {
        let _that = this;
        $init(()=>{
            let confit = {
                share_friend_title: "请查阅您的专属定制方案",
                share_friend_desc: "AI-LiNK冷暖风水专业集成系统定制方案",
                share_img_url:
                    "https://aotest-lottery.iwxapi.com/core/images2020/watersystem/ant/share_img.png",
                share_link: `${window.location.protocol}//${window.location.host}${window.location.pathname}?from=prohibit&id=${_that.$route.query.id}`,
            };
            getWxSingleConfig(confit);
            if (_that.$route.query.from == "prohibit") {
                wx.ready(() => {
                    wx.hideOptionMenu();
                });
            }
            
            path.post5(path.cmsPdfPath, {
                id: _that.$route.query.id,
                client_type: _that.isIPhoneX(),
            }).then((res) => {
                let pdfUrl = res.data.data.result;
                _that.pdfUrl = pdfUrl;
            });
        })
    },
    methods: {
        isIPhoneX() {
            var u = navigator.userAgent;
            var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
            if (isiOS) {
                return 0;
            } else if (isAndroid) {
                return 1;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.content {
    width: 100%;
    height: 100vh;
    iframe {
        width: 100%;
        height: 100%;
    }
}
</style>